import { render, staticRenderFns } from "./EjectionForce.vue?vue&type=template&id=133278ac&scoped=true&"
import script from "./EjectionForce.vue?vue&type=script&lang=ts&"
export * from "./EjectionForce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133278ac",
  null
  
)

export default component.exports